// gatsby-browser.tsx
import type { GatsbyBrowser } from 'gatsby';
import * as React from 'react';
import { CampaignProvider } from './src/context/CampaignContext';
import './src/styles/global.css';

// (Opcional) Tipar window.plausible para evitar "any"
declare global {
  interface Window {
    plausible?: (
      event: string,
      options?: { props?: Record<string, any> }
    ) => void;
  }
}

// Se ejecuta en cada cambio de ruta (SPA)
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = () => {
  if (typeof window !== 'undefined' && window.plausible) {
    window.plausible('pageview');
  }
};

// Tu provider sigue igual
export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => <CampaignProvider>{element}</CampaignProvider>;
